import React, { useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import CircularProgress from '@material-ui/core/CircularProgress';
import { removeAppsTutorial } from '../../../crud/apps-tutorial.crud';
import { injectIntl } from "react-intl";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import ApiErrorMessage from "../../../crud/api.errorMessage";
import { connect } from "react-redux";
import * as appsTutorial from "../../../store/ducks/apps-tutorial.duck";
const RemoveAppsTutorial = (props) => {
    const { classes, intl } = props;
    const [loading,
        setLoading] = useState(false);

    const handleDelete = () => {
        setLoading(true);
        removeAppsTutorial(props.appsTutorial._id).then((output) => {
            if (output.data.success) {
                props.appsTutorialUpdated({ skip: 0, limit: 5, userType: props.userType });
                setLoading(false);
                toast.success('Tutorial is successfully deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
                props.handleClose();
            }
        }).catch((error) => {
            console.log('error', error);
            setLoading(false);
            if (error.response) {
                // Request made and server responded
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                toast.error(intl.formatMessage({
                    id: ApiErrorMessage[error.response.data.errorCode]
                }, { title: props.appsTutorial.title }), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });

    };

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={props.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.appsTutorial.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure to delete this tutorial?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.handleClose}>
                        No
                    </Button>

                    <Button
                        variant="primary"
                        style={{
                            position: "relative"
                        }}
                        onClick={() => handleDelete(props.appsTutorial._id)}
                        disabled={loading}>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return { data: state };
};

const mapDispatchToProps = dispatch => {
    return {
        appsTutorialUpdated: ({ skip, limit, userType }) => dispatch(appsTutorial.actions.appsTutorialUpdated({ skip, limit, userType }))
    };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles((theme) => ({
    ...styles(theme)
}), { withTheme: true })(RemoveAppsTutorial)));
